export default __webpack_public_path__ + "static/media/logo_horizontal_keto.90a6764f.svg";